import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const mediaUrl = (path) => (path ? `${API}/media/${path}` : "");

export const api = axios.create({ baseURL: API, withCredentials: true });

export const getConfig = () => api.get("/config").then((r) => r.data);
export const listPresets = () => api.get("/presets").then((r) => r.data);
export const createPreset = (payload) => api.post("/presets", payload).then((r) => r.data);
export const deletePreset = (id) => api.delete(`/presets/${id}`).then((r) => r.data);
export const renamePreset = (id, name) => api.patch(`/presets/${id}`, { name }).then((r) => r.data);
export const dailyAutofill = (source, id) => api.post("/daily/autofill", { source, id }).then((r) => r.data);
export const remixVideo = (pid, opts = {}) => api.post(`/videos/${pid}/remix`, opts).then((r) => r.data);
export const savePresetFromVideo = (pid, name) => api.post(`/videos/${pid}/preset`, { name: name || null }).then((r) => r.data);

// ---- Daily Fresh Video ----
export const getDailySettings = () => api.get("/daily/settings").then((r) => r.data);
export const saveBrandProfile = (profile) => api.put("/daily/profile", profile).then((r) => r.data);
export const saveDailySettings = (settings) => api.put("/daily/settings", settings).then((r) => r.data);
export const runDailyNow = () => api.post("/daily/run").then((r) => r.data);
export const getDailyHistory = () => api.get("/daily/history").then((r) => r.data);
export const previewDailyConcept = () => api.post("/daily/preview").then((r) => r.data);
export const approveDailyConcept = () => api.post("/daily/approve").then((r) => r.data);
export const discardDailyConcept = () => api.post("/daily/discard").then((r) => r.data);
export const getDailyCalendar = () => api.get("/daily/calendar").then((r) => r.data);
export const planDailyCalendar = () => api.post("/daily/calendar/plan").then((r) => r.data);
export const getCalendarStatus = () => api.get("/daily/calendar/status").then((r) => r.data);
export const approveCalendarEntry = (id) => api.post(`/daily/calendar/${id}/approve`).then((r) => r.data);
export const regenerateCalendarEntry = (id) => api.post(`/daily/calendar/${id}/regenerate`).then((r) => r.data);
export const deleteCalendarEntry = (id) => api.delete(`/daily/calendar/${id}`).then((r) => r.data);
export const approveAllCalendar = () => api.post("/daily/calendar/approve-all").then((r) => r.data);
export const previewAssetScene = (path, role) => api.post("/daily/assets/preview", { path, role }).then((r) => r.data);
export const listVideos = () => api.get("/videos").then((r) => r.data);
export const getVideo = (id) => api.get(`/videos/${id}`).then((r) => r.data);
export const createVideo = (payload) => api.post("/videos", payload).then((r) => r.data);
export const retryVideo = (id) => api.post(`/videos/${id}/retry`).then((r) => r.data);
export const updateAffiliate = (id, aff) => api.put(`/videos/${id}/affiliate`, aff).then((r) => r.data);
export const trackView = (id) => api.post(`/track/view/${id}`).then((r) => r.data).catch(() => {});
export const getAnalytics = () => api.get("/analytics").then((r) => r.data);
export const goUrl = (id, src) => `${API}/go/${id}?src=${src}`;
export const deleteVideo = (id) => api.delete(`/videos/${id}`).then((r) => r.data);

// ---- Social publishing (real OAuth, credential-gated) ----
export const getSocialPlatforms = () => api.get("/social/platforms").then((r) => r.data);
export const getSocialAccounts = () => api.get("/social/accounts").then((r) => r.data);
export const validateSocialUrl = (url) => api.post("/social/validate-url", { url }).then((r) => r.data);
export const startSocialOAuth = (platform) => api.get(`/social/oauth/${platform}/authorize`).then((r) => r.data);
export const disconnectSocial = (platform) => api.post(`/social/disconnect/${platform}`).then((r) => r.data);
export const getAutopost = () => api.get("/social/autopost").then((r) => r.data);
export const setAutopost = (prefs) => api.put("/social/autopost", prefs).then((r) => r.data);
export const publishVideo = (id, payload) => api.post(`/videos/${id}/publish`, payload).then((r) => r.data);
export const getVideoPosts = (id) => api.get(`/videos/${id}/posts`).then((r) => r.data);
export const retryPost = (jobId) => api.post(`/social/jobs/${jobId}/retry`).then((r) => r.data);
export const cancelPost = (jobId) => api.post(`/social/jobs/${jobId}/cancel`).then((r) => r.data);
export const adminSocialOverview = () => api.get("/admin/social/overview").then((r) => r.data);
export const getSocialAnalytics = () => api.get("/social/analytics").then((r) => r.data);
export const refreshSocialMetrics = () => api.post("/social/metrics/refresh").then((r) => r.data);
export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

// ---- Auth ----
export const authRegister = (payload) => api.post("/auth/register", payload).then((r) => r.data);
export const authLogin = (payload) => api.post("/auth/login", payload).then((r) => r.data);
export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const authLogout = () => api.post("/auth/logout").then((r) => r.data);
export const googleSession = (sessionId) =>
  api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } }).then((r) => r.data);

// ---- Payments ----
export const getPlans = () => api.get("/payments/plans").then((r) => r.data);
export const switchPlan = (lookup_key) => api.post("/payments/switch-plan", { lookup_key }).then((r) => r.data);
export const startCheckout = (lookup_key) =>
  api.post("/payments/checkout", { lookup_key, origin_url: window.location.origin }).then((r) => r.data);
export const paymentStatus = (sessionId) => api.get(`/payments/status/${sessionId}`).then((r) => r.data);

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
};
